/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_Front_Mare_HonorInputs */

const en_sleek_front_mare_honor = /** @type {(inputs: Sleek_Front_Mare_HonorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const de_sleek_front_mare_honor = /** @type {(inputs: Sleek_Front_Mare_HonorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Sleek_Front_Mare_HonorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sleek_front_mare_honor = /** @type {((inputs?: Sleek_Front_Mare_HonorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_Front_Mare_HonorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sleek_front_mare_honor(inputs)
	return de_sleek_front_mare_honor(inputs)
});